import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {PackageGet, PackageReleasePost, ReleaseType} from '@vtp/vtpcap-client-ts';
import {CapabilitiesService} from 'src/app/services/capabilities/capabilities.service';
import {NotificationService} from 'src/app/services/notification/notification.service';
import {VpackageService} from './vpackage.service';

@Injectable({
  providedIn: 'root',
})
export class VpackagereleaseService {
  constructor(
    private capabilitiesService: CapabilitiesService,
    private router: Router,
    private notificationService: NotificationService,
    private vPackageService: VpackageService
  ) {
  }

  uploadAbortController: AbortController | null = null;
  valid: boolean = false;
  packageOverview?: PackageGet;
  presignedData?: any;
  vPackageReleaseId?: string;
  packageReleaseOverview?: any;
  modelseries: any;
  DiagnosticName: any;
  releaseList?: { [id: string]: { id: string } };
  packageType: string = '';
  packageReleaseInitMultipart: any = {};

  packageReleasePost: PackageReleasePost = {
    description: '',
    model_series: [],
    name: '',
    package_releases: undefined,
    release_type: ReleaseType.Beta,
    conditions: '',
    package: {id: ''},
    variant_info: undefined,
    application_instances: {
      use_selected_manifest: true,
      ncd_release: '',
      vecu_applications: [],
      sensor_actors: [],
      semantic_version: '',
      hardware_security_module: {},
    },
  };

  prepareApps(): void {
    if (this.packageReleasePost.application_instances) {
      this.packageReleasePost.application_instances!.manifests = [];

      this.packageReleasePost.application_instances!.manifests.push({
        file_name: '',
        file_type: 'ecu-extract',
      });
      this.packageReleasePost.application_instances!.manifests.push({
        file_name: '',
        file_type: 'odx-d',
      });
      this.packageReleasePost.application_instances!.manifests.push({
        file_name: '',
        file_type: 'candela',
      });
      this.packageReleasePost.application_instances!.manifests.push({
        file_name: '',
        file_type: 'smr-d',
      });
    }
  }

  postPackageRelease(): void {
    /*     this.packageReleasePost.variant_info = 'test'; */
    if (this.vPackageService.packageOverview.type === 'vECUPKG') {
      if (!this.packageReleasePost.application_instances?.sensor_actors?.length) {
        delete this.packageReleasePost.application_instances!.sensor_actors;
      }
    }

    if (this.packageReleasePost!.application_instances?.manifests)
      this.packageReleasePost!.application_instances!.manifests! = this.packageReleasePost!.application_instances!.manifests!.filter((manifest) => manifest.file_name);

    this.capabilitiesService
      .postPackageRelease(this.packageReleasePost!)
      .subscribe({
        next: (response) => {
          this.presignedData = response.data.presigned_s3_url;
          this.notificationService.notifySuccess = true;
          this.notificationService.notificationSuccesMessage = response.message;
         if (this.presignedData.url != null && this.packageType == 'vECUPKG') {
          this.router.navigate(['vpackagerelease/upload']);
         }else{
          this.router.navigate(['vpackages']);
         }
        },
        error: (err) => {
          this.notificationService.handleError(err);
        },
      });
  }

  postPackageReleaseMultiPart(): void {
    if (this.vPackageService.packageOverview.type === 'vECUPKG') {
      if (!this.packageReleasePost.application_instances?.sensor_actors?.length) {
        delete this.packageReleasePost.application_instances!.sensor_actors;
      }
    }

    if (this.packageReleasePost!.application_instances?.manifests)
      this.packageReleasePost!.application_instances!.manifests! = this.packageReleasePost!.application_instances!.manifests!.filter((manifest) => manifest.file_name);

    this.capabilitiesService
      . postPackageReleaseMultipart(this.packageReleasePost!)
      .subscribe({
        next: (response) => {
          this.vPackageReleaseId = response.data.id;
          this.packageReleaseInitMultipart = response.data.init_multipart;
          this.notificationService.notifySuccess = true;
          this.notificationService.notificationSuccesMessage = response.message;
         if (this.packageReleaseInitMultipart != null && this.packageType == 'vECUPKG') {
          this.router.navigate(['vpackagerelease/upload']);
         }else{
          this.router.navigate(['vpackages']);
         }
        },
        error: (err) => {
          this.notificationService.handleError(err);
        },
      });
  }

  uploadFileInChunks(file: any, chunkSize: number, onProgress?: (percent: number, isComplete?: boolean) => void,
    isCancelled?: () => boolean
  ): void {
    const totalChunks = Math.ceil(file.size / chunkSize);
    this.uploadAbortController = new AbortController();

    const request = {
      object_name: this.packageReleaseInitMultipart.object_name,
      upload_id: this.packageReleaseInitMultipart.upload_id,
      no_of_parts: totalChunks
    };
  
    this.capabilitiesService.postMultipartUploadGeneratePrsignedUrls(request).subscribe({
      next: async (response) => {
        const urls = response.data.items;
        if (!urls || urls.length !== totalChunks) {
          console.error("Error fetching presigned URLs!");
          return;
        }
  
        const MAX_CONCURRENT_UPLOADS = 5;
        let uploadQueue: Promise<void>[] = [];
        let uploadedChunks = 0;
  
        for (let i = 0; i < totalChunks; i++) {
          if (isCancelled?.()) {
            console.warn("Upload cancelled by user.");
            return;
          }
  
          const offset = i * chunkSize;
          const chunk = file.slice(offset, offset + chunkSize);
          const presignedUrl = urls[i].url;
  
          uploadQueue.push(this.uploadChunkWithRetry(chunk, presignedUrl, 3, i, totalChunks));
  
          if (uploadQueue.length >= MAX_CONCURRENT_UPLOADS) {
            await Promise.all(uploadQueue);
            uploadQueue = [];
          }
  
          uploadedChunks++;
          if (onProgress) {
            const progress = Math.round((uploadedChunks / totalChunks) * 100);
            // Cap at 99% until final API confirmation
            onProgress(Math.min(progress, 99));
          }
        }
        await Promise.all(uploadQueue);
  
        if (isCancelled?.()) {
          console.warn("Upload cancelled after chunking but before completion.");
          return;
        } 
        // Finalize the multipart upload
        this.capabilitiesService.postMultipartUploadCompleteMultipartUpload({
          object_name: this.packageReleaseInitMultipart.object_name,
          upload_id: this.packageReleaseInitMultipart.upload_id,
        }).subscribe(() => {
          this.clearAll();
          this.router.navigate(['vpackages']);
          if (onProgress) {
            onProgress(100, true); // ✅ Final update at 100% only after successful completion
          }
        });
      },
      error: (error) => {
        this.notificationService.handleError(error);
      }
    });
  }

  initMulitpartOnCancel(){
    this.capabilitiesService.getPackageReleaseInitMultipartUpload(this.vPackageReleaseId!).subscribe({
      next:(response) => { 
        this.packageReleaseInitMultipart = response.data.init_multipart;
      },
    })
    this.uploadAbortController?.abort();
    this.uploadAbortController = null;
   }

async uploadChunkWithRetry(chunk: Blob, presignedUrl: string, maxAttempts: number, chunkIndex: number, totalChunks: number): Promise<void> {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
          const response = await fetch(presignedUrl, {
              method: "PUT",
              body: chunk,
              headers: { "Content-Type": "application/octet-stream" },
              signal: this.uploadAbortController?.signal 
          });

          if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
          }
          return; // Exit retry loop on success

      } catch (error: any) {
        if (error.name === 'AbortError') {
          console.warn(`Upload aborted for chunk ${chunkIndex + 1}`);
          return;
        }
          console.warn(`Upload attempt ${attempt}/${maxAttempts} failed for chunk ${chunkIndex + 1}. Retrying...`, error);
          await new Promise(resolve => setTimeout(resolve, Math.pow(2, attempt) * 1000)); // 1s, 2s, 4s...
      }
  }
}



  uploadVEcu(file: File): void {
    const formData = new FormData();

    Object.keys(this.presignedData.fields).forEach((key) => {
      formData.append(key, this.presignedData.fields[key]);
    });

    formData.append('file', file);

    this.capabilitiesService
      .uploadFile(formData, this.presignedData.url)
      .subscribe({
        next: (response) => {
          this.notificationService.notifySuccess = true;
          this.notificationService.notificationSuccesMessage = response.message;
        },
        complete: () => {
          this.clearAll();
          this.router.navigate(['vpackages']);
        },
        error: (error) => {
          this.notificationService.handleError(error);
        },
      });
  }

  setModelSeries(modelseries: any): void {
    this.modelseries = modelseries;
  }

  getModelSeries() {
    return this.modelseries;
  }

  setDiagnosticName(diagnosticName: any): void {
    this.DiagnosticName = diagnosticName;
  }

  getDiagnosticName() {
    return this.DiagnosticName;
  }

  clearAll(): void {
    this.valid = false;

    this.packageOverview = undefined;
    this.presignedData = undefined;
    this.packageReleasePost = {
      description: '',
      model_series: [],
      name: '',
      package_releases: null,
      release_type: ReleaseType.Beta,
      conditions: '',
      package: {id: ''},
      // variant_info: '',
      application_instances: {
        ncd_release: '',
        vecu_applications: [],
        sensor_actors: [],
        semantic_version: '',
        hardware_security_module: {},
      },
    };
  }
}
